Vue.directive('masonry', {
    inserted: function (el, nodeObj) {

        Vue.nextTick(function(){

            if (!Isotope) {
                throw new Error('Isotope plugin is not defined. Please check it\'s connected and parsed correctly.')
            }

            var container = el.querySelector('.Masonry__items');
            var timeout = false;

            var isotope = new Isotope(container, {
                percentPosition: true,
                masonry: { gutter: 40 }
            });

            var imgLoad = imagesLoaded( container );

            imgLoad.on( 'progress', function() {

                clearTimeout(timeout);
                timeout = setTimeout(function(){ isotope.arrange() }, 1000);
            });

            imgLoad.on( 'done', function() {

                var imgs = el.querySelectorAll('[data-src]');
                for (i = 0; i < imgs.length; ++i) {
                    imgs[i].setAttribute('src', imgs[i].getAttribute('data-src'));
                }

                imgLoad = imagesLoaded( container );

                imgLoad.on( 'progress', function() {
                    clearTimeout(timeout);
                    timeout = setTimeout(function(){ isotope.arrange() }, 1000);
                });
            });

            var filters = el.querySelectorAll('.Masonry__filter');

            for (var i=0;i<filters.length; i++)
            {
                filters[i].addEventListener('click', function(){

                    for (var i=0;i<filters.length; i++)
                        filters[i].classList.remove('is-active');

                    this.classList.add('is-active');

                    isotope.arrange({
                        filter: this.getAttribute("data-filter")
                    })
                });
            }

            var more = el.querySelector('.Masonry__more .button');

            if( more )
            {
                more.addEventListener('click', function(){

                    for (var i=0;i<filters.length; i++)
                        filters[i].classList.remove('is-active');

                    this.classList.add('is-active');

                    isotope.arrange({
                        filter: this.getAttribute("data-filter")
                    })
                });
            }
        });
    }
});
